import { type TScheduledOrdersState } from './types';

export const initialScheduledOrdersState: TScheduledOrdersState = {
    deletingOrder: null,
    deletingFundings: [],
    deletingOrderAnswers: {
        overview: { deleteScheduledOrderCheckbox: false },
    },
};
